/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui'

import {
  DownloadPlatformsStyled,
  DownloadPlatformsInnerStyled,
  DownloadPlatformsTitleStyled,
  DownloadPlatformsSubitleStyled,
  DownloadPlatformsContentStyled,
  DownloadPlatformsListStyled
} from './styles'
import { DownloadPlatformsProps } from './types'
import PlatformsList from '../PlatformsList'

const DownloadPlatforms: React.FC<DownloadPlatformsProps> = ({ data: { title, subtitle, listItems } }) => (
  <DownloadPlatformsStyled>
    <DownloadPlatformsInnerStyled>
      <DownloadPlatformsContentStyled>
        {title && (
          <DownloadPlatformsTitleStyled as="h2" variant="headingRaleway6">
            {title}
          </DownloadPlatformsTitleStyled>
        )}
        {subtitle && (
          <DownloadPlatformsSubitleStyled as="p" variant="bodyMontserrat10">
            {subtitle}
          </DownloadPlatformsSubitleStyled>
        )}
      </DownloadPlatformsContentStyled>
      <DownloadPlatformsListStyled>
        <PlatformsList {...{ listItems }} />
      </DownloadPlatformsListStyled>
    </DownloadPlatformsInnerStyled>
  </DownloadPlatformsStyled>
)

export default DownloadPlatforms
